<input type="checkbox" id="menu-trigger" [checked]="showHamburger" (change)="toggleHamburger()" />
<div class="header header--client" [ngClass]="{ 'header--home': routeIsHome, 'header--faq': routeIsFaq }">
  <div class="header__content">
    <div class="header__icons">
      <a class="header__logo" routerLink="home">
        <ng-container *ngIf="routeIsHome || routeIsFaq; then logoIsWhite; else logoIsBlue"></ng-container>

        <ng-template #logoIsWhite>
          <div class="header__logo-image--white" alt="Coverpath"></div>
        </ng-template>
        <ng-template #logoIsBlue>
          <div class="header__logo-image--blue" alt="Coverpath"></div>
        </ng-template>
      </a>
      <label class="header__nav-menu" for="menu-trigger">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </label>
    </div>
    <div class="header__nav-wrapper">
      <ul *ngIf="!controller.loggedIn" class="header__nav">
        <li class="header__nav-item">
          <a class="text-link--header-client" routerLink="help" (click)="hideHamburger()">Help</a>
        </li>
        <li class="header__nav-item">
          <a class="text-link--header-client" href="javascript:void(0)" (click)="hideHamburger(); login()">Login</a>
        </li>
        <li
          *ngIf="
            !nbDecommissionPost30Days &&
            !routeIsHome &&
            !routeIsSignComplete &&
            !routeIsHelp &&
            !routeIsAcknowledgement &&
            isTerm
          "
          class="header__nav-item"
        >
          <a class="header__button button button--small" routerLink="home" role="button" (click)="hideHamburger()">
            Get a Quote
          </a>
        </li>
        <li
          *ngIf="!nbDecommissionPost30Days && routeIsHome && isTerm && !isART && doesQuickQuoteExist()"
          class="header__nav-item"
        >
          <a
            class="header__button button button--small"
            href="javascript:void(0)"
            role="button"
            (click)="scrollToQuickQuote(); hideHamburger()"
          >
            Get a Quote
          </a>
        </li>
      </ul>
      <ul *ngIf="controller.loggedIn" class="header__nav">
        <li class="header__nav-item">
          <a class="text-link--header-client" routerLink="account-center" (click)="hideHamburger()">Policies</a>
        </li>
        <li class="header__nav-item">
          <a class="text-link--header-client" routerLink="help" (click)="hideHamburger()">Help</a>
        </li>
        <li class="header__nav-item">
          <a class="text-link--header-client" routerLink="faq" (click)="hideHamburger()">FAQ</a>
        </li>
        <li class="header__nav-item">
          <a class="text-link--header-client" routerLink="settings" (click)="hideHamburger()">Settings</a>
        </li>
        <li class="header__nav-item">
          <a class="text-link--header-client" (click)="hideHamburger(); logout()">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</div>
